import { enableProdMode } from '@angular/core';
import { environment } from '@Env';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import './utils';
import './polyfills';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeFr, 'fr');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
